/* eslint-disable */
import * as Types from '../../../types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from 'graphql-tag';
import { OfferTagsFragmentDoc } from '../../../components/organisms/offer/OfferTags/OfferTags.generated';
export type OffersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OffersQuery = { __typename: 'Query', offers: Array<{ __typename: 'Offer', id: string, slug: string, name: string, cardImageUrl?: string | null, status: Types.OfferStatus, hideOffer?: boolean | null, openDate?: string | null, digitalSubscription: Types.OfferDigitalSubscription, subtitle?: string | null, fund: { __typename: 'Fund', id: string, summary: { __typename: 'FundSummary', content: string } }, details?: Array<{ __typename: 'IndexedKeyValue', index: number, key: string, value: string }> | null }>, funds: Array<{ __typename: 'Fund', id: string, name: string, cardImageUrl: string, summary: { __typename: 'FundSummary', content: string }, exitDetails?: { __typename: 'FundExitDetails' } | null }> };

export type CheckForOpenTradesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CheckForOpenTradesQuery = { __typename: 'Query', sellOrders: Array<{ __typename: 'SellOrder', id: string, status: Types.SellOrderStatus }> };


export const OffersDocument = gql`
    query Offers {
  offers {
    id
    slug
    name
    cardImageUrl
    status
    hideOffer
    openDate
    digitalSubscription
    fund {
      id
      summary {
        content
      }
    }
    subtitle
    details {
      index
      key
      value
    }
    ...OfferTags
  }
  funds {
    id
    name
    cardImageUrl
    summary {
      content
    }
    exitDetails {
      __typename
    }
  }
}
    ${OfferTagsFragmentDoc}` as unknown as DocumentNode<OffersQuery, OffersQueryVariables>;
export const CheckForOpenTradesDocument = gql`
    query CheckForOpenTrades {
  sellOrders {
    id
    status
  }
}
    ` as unknown as DocumentNode<CheckForOpenTradesQuery, CheckForOpenTradesQueryVariables>;